import type { VideoData, VideoParser } from './video';
import { InvalidVideo } from './videoErrors';

const isValidUrl = (url: string): boolean => {
  const regex =
    /^(https?:\/\/)?((share|video)\.vidyard\.com\/watch\/|embed\.vidyard\.com\/share\/|play\.vidyard\.com\/|[\w-]+\.hubs\.vidyard\.com\/watch\/)[\w-]+/;
  return regex.test(url);
};

const getContentData = async (url: string): Promise<VideoData> => {
  const metadata = await getMetadata(url);
  const videoId = getVideoId(metadata.html);

  return {
    type: 'vidyard',
    title: metadata.title,
    author: '',
    thumbnail: `https://play.vidyard.com/${videoId}.jpg`,
    videoId,
  };
};

const getVideoId = (html: string) => {
  const match = html?.match(/data-uuid="([\w-]+)"/);
  if (!match) {
    throw new InvalidVideo();
  }

  return match[1];
};

const getMetadata = async (url: string) => {
  const apiUrl = `https://api.vidyard.com/dashboard/v1.1/oembed?format=json&url=${encodeURIComponent(url)}`;

  try {
    const response = await fetch(apiUrl);
    if (!response.ok) throw new InvalidVideo();

    return await response.json();
  } catch (error) {
    throw new InvalidVideo();
  }
};

export const vidyardVideo: VideoParser = {
  isValidUrl,
  getContentData,
};
